export const abbreviateNumber = (number: number) => {
	const units = ['', 'K', 'M', 'B', 'T'];
	let unitIndex = 0;

	while (number >= 1000 && unitIndex < units.length - 1) {
		number /= 1000;
		unitIndex++;
	}

	return `${Math.floor(number * 10) / 10}${units[unitIndex]}`;
};
